import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Spinner from "../../../presentation/spinner";
import ZoneSelector from "../ZoneSelector";
import api from "../../../../services/api";
import { simulateNewOrder, getZoneValidationError } from "./helpers";
import "./style.css";

export default ({
  showModal,
  onHideModal,
  accountId,
  onStoredSimulationsUpdated,
}) => {
  const [customerName, setCustomerName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [carPlate, setCarPlate] = useState("");
  const [carMake, setCarMake] = useState("");
  const [carColor, setCarColor] = useState("");
  const [startDistance, setStartDistance] = useState("");
  const [intervalTime, setIntervalTime] = useState("");
  const [intervalDistance, setIntervalDistance] = useState("");
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedZone, setSelectedZone] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [isCreatingSimulation, setIsCreatingSimulation] = useState(false);

  const accessToken = localStorage.getItem("idToken");
  // GET PROJECTS WHEN ACCESSTOKEN IS UPDATED
  useEffect(() => {
    async function fetchProjects() {
      try {
        if (accessToken) {
          const projects = await api.getProjects(accountId, accessToken);
          setProjects(projects);
        }
      } catch (error) {
        console.log("error", error);
        alert("There was an issue loading the Projects");
      }
    }

    fetchProjects();
  }, [accessToken, accountId]);

  const onSelectZone = (selectedZone) => {
    setSelectedZone(selectedZone);
    const zoneValidationError = getZoneValidationError(selectedZone);
    if (!zoneValidationError) {
      setValidationErrors((previousValidationErrors) => {
        const newValidationErrors = {
          ...previousValidationErrors,
        };
        delete newValidationErrors.zone;
        return newValidationErrors;
      });
    } else {
      setValidationErrors((previousValidationErrors) => ({
        ...previousValidationErrors,
        zone: zoneValidationError,
      }));
    }
  };

  const resetAllValues = () => {
    setCustomerName("");
    setMobileNumber("");
    setCarPlate("");
    setCarMake("");
    setCarColor("");
    setSelectedProject("");
    setSelectedZone(null);
    setStartDistance("");
    setIntervalDistance("");
    setIntervalTime("");
    setValidationErrors({});
  };

  return (
    <Modal
      show={showModal}
      onHide={() => {
        resetAllValues();
        onHideModal();
      }}
      enforceFocus={false}
    >
      <div className="simulations-modal-wrapper">
        <h1 className="simulations-modal-heading">Simulate an order</h1>
        <div>
          <FormControl
            variant="outlined"
            className="simulations-select-project-wrapper"
          >
            <label
              htmlFor="project-selector"
              className="simulations-input-label"
            >
              Project:
            </label>
            <Select
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.target.value)}
              width={20}
              disabled={!(projects && projects.length)}
              id="project-selector"
              className="simulations-project-selector-override"
            >
              {projects.map((project) => (
                <MenuItem key={project._id} value={project}>
                  {project.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <ZoneSelector
            projectId={selectedProject ? selectedProject._id : undefined}
            onSelectZone={onSelectZone}
          />
          {validationErrors.zone && (
            <p className="simulation-validation-error">
              {validationErrors.zone}
            </p>
          )}
        </div>
        <div>
          <h3>Set the customer details</h3>
          <h5>
            If the fields are left blank (except Customer Name) then the
            simulation will be run with auto generated default values
          </h5>
          <div className="simulation-input-field-grid">
            <div>
              <label htmlFor="customerName" className="pull-left">
                Customer Name (Required)
              </label>
              <input
                type="text"
                className="form-control"
                id="customerName"
                name="customerName"
                placeholder="Customer Name"
                value={customerName}
                onChange={(event) => {
                  setCustomerName(event.target.value);
                  if (validationErrors.customerName && event.target.value) {
                    setValidationErrors((previousValidationErrors) => {
                      const newValidationErrors = {
                        ...previousValidationErrors,
                      };
                      delete newValidationErrors.customerName;
                      return newValidationErrors;
                    });
                  }
                }}
              />
              {validationErrors.customerName && (
                <p className="simulation-validation-error">
                  {validationErrors.customerName}
                </p>
              )}
            </div>
            <div>
              <label htmlFor="mobileNumber" className="pull-left">
                Mobile Number
              </label>
              <input
                type="text"
                className="form-control"
                id="mobileNumber"
                name="mobileNumber"
                placeholder="Mobile Number"
                value={mobileNumber}
                onChange={(event) => setMobileNumber(event.target.value)}
              />
            </div>
            <div>
              <label htmlFor="carPlate" className="pull-left">
                Car Plate
              </label>
              <input
                type="text"
                className="form-control"
                id="carPlate"
                name="carPlate"
                placeholder="Car Plate"
                value={carPlate}
                onChange={(event) => setCarPlate(event.target.value)}
              />
            </div>
            <div>
              <label htmlFor="carMake" className="pull-left">
                Car Make
              </label>
              <input
                type="text"
                className="form-control"
                id="carMake"
                name="carMake"
                placeholder="Car Make"
                value={carMake}
                onChange={(event) => setCarMake(event.target.value)}
              />
            </div>
            <div>
              <label htmlFor="carColor" className="pull-left">
                Car Color
              </label>
              <input
                type="text"
                className="form-control"
                id="carColor"
                name="carColor"
                placeholder="Car Color"
                value={carColor}
                onChange={(event) => setCarColor(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div>
          <h3>Simulation Parameters</h3>
          <h5>
            If the fields are left blank then the simulation will be run with
            the following default values: starting distance of 5km, distnce
            interval of 500m and time interval of 1 min
          </h5>
          <div className="simulation-input-field-grid">
            <div>
              <label htmlFor="startDistance" className="pull-left">
                Start Distance (Metres)
              </label>
              <input
                type="number"
                className="form-control"
                id="startDistance"
                name="startDistance"
                placeholder="Start Distance"
                value={startDistance}
                onChange={(event) => setStartDistance(event.target.value)}
              />
            </div>
            <div>
              <label htmlFor="intervalTime" className="pull-left">
                Interval Time (Seconds)
              </label>
              <input
                type="number"
                className="form-control"
                id="intervalTime"
                name="intervalTime"
                placeholder="Interval Time"
                value={intervalTime}
                onChange={(event) => setIntervalTime(event.target.value)}
              />
            </div>
            <div>
              <label htmlFor="intervalDistance" className="pull-left">
                Interval Distance (Metres)
              </label>
              <input
                type="number"
                className="form-control"
                id="intervalDistance"
                name="intervalDistance"
                placeholder="Interval Distance"
                value={intervalDistance}
                onChange={(event) => setIntervalDistance(event.target.value)}
              />
            </div>
          </div>
        </div>
        <Button
          disabled={isCreatingSimulation}
          variant="contained"
          className="create-simulation-button"
          onClick={async () => {
            if (isCreatingSimulation) {
              return;
            }
            setIsCreatingSimulation(true);
            const validationErrors = {};
            const zoneValidationError = getZoneValidationError(selectedZone);
            if (zoneValidationError) {
              validationErrors.zone = zoneValidationError;
            }
            if (!customerName) {
              validationErrors.customerName = "Customer Name is required";
            }
            if (Object.keys(validationErrors).length) {
              setValidationErrors(validationErrors);
            } else {
              setValidationErrors({});
              await simulateNewOrder(
                selectedProject,
                selectedZone,
                customerName,
                carMake,
                carPlate,
                startDistance,
                intervalTime,
                intervalDistance
              );
              onStoredSimulationsUpdated();
            }
            setIsCreatingSimulation(false);
          }}
        >
          {isCreatingSimulation ? <Spinner /> : "Start"}
        </Button>
      </div>
    </Modal>
  );
};
